/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Fit_4Inputs */

const en_pc_alt_fit_4 = /** @type {(inputs: Pc_Alt_Fit_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You handle confidential files and want no telemetry and no cloud processing.`)
};

const zh_pc_alt_fit_4 = /** @type {(inputs: Pc_Alt_Fit_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你处理机密文件，不希望有遥测或云端处理。`)
};

/**
* | output |
* | --- |
* | "You handle confidential files and want no telemetry and no cloud processing." |
*
* @param {Pc_Alt_Fit_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_fit_4 = /** @type {((inputs?: Pc_Alt_Fit_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Fit_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_fit_4(inputs)
	return zh_pc_alt_fit_4(inputs)
});
export { pc_alt_fit_4 as "pc.alt.fit.4" }